import { testimonialData } from '@/mocks/categories';

export default function Testimonials() {
  return (
    <section className="py-24 md:py-32 bg-gradient-to-b from-background-50 to-accent-50/30">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="flex items-center justify-center gap-3 mb-4">
            <span className="w-2 h-2 rounded-full bg-accent-500"></span>
            <span className="text-[12px] font-semibold text-foreground-400 uppercase tracking-[0.1em] whitespace-nowrap">
              OPINIE UŻYTKOWNIKÓW
            </span>
          </div>
          <h2 className="font-heading text-4xl md:text-5xl text-foreground-900 font-bold leading-[1.2] mb-4">
            Zobacz co mówią<br />nasi użytkownicy
          </h2>
          <p className="text-[16px] text-foreground-500 font-body">
            Niezależne opinie o korzystaniu z Kakobuy Spreadsheet.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {testimonialData.map((t, idx) => (
            <div
              key={t.name}
              className={`bg-white rounded-2xl p-6 md:p-7 transition-all duration-300 hover:scale-[1.02] ${
                idx >= 4 ? 'opacity-70 hover:opacity-100' : ''
              }`}
            >
              <div className="flex gap-1 mb-4">
                {Array.from({ length: t.rating }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-accent-500 text-sm"></i>
                ))}
                {t.rating < 5 && (
                  <i className="ri-star-line text-foreground-300 text-sm"></i>
                )}
              </div>
              <h4 className="text-[18px] font-bold text-foreground-900 mb-3 font-body">
                {t.title}
              </h4>
              <p className="text-[14px] text-foreground-600 leading-relaxed mb-5 font-body">
                {t.text}
              </p>
              <div className="flex items-center gap-3 pt-4 border-t border-foreground-100">
                <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center">
                  <span className="text-[13px] font-bold text-primary-700">{t.avatar}</span>
                </div>
                <div>
                  <p className="text-[14px] font-semibold text-foreground-900 whitespace-nowrap">{t.name}</p>
                  <p className="text-[12px] text-foreground-400 whitespace-nowrap">{t.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <div className="inline-flex items-center gap-6">
            <div className="flex items-center gap-2">
              <span className="text-2xl font-bold text-foreground-900 font-heading">4.9</span>
              <div className="flex gap-0.5">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-accent-500 text-sm"></i>
                ))}
              </div>
            </div>
            <span className="text-[14px] text-foreground-400 font-body whitespace-nowrap">
              Średnia ocena od 200+ użytkowników
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}